import { useState } from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'
import { sendPasswordResetEmail } from '@/actions/storeActions'
import { useSnackbar } from '@/utilities/hooks'
import LoginFrame from '@/components/LoginFrame'
import ForgotPasswordComplete from './ForgotPasswordComplete'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)
  const { showAlertSnackbar } = useSnackbar()

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    try {
      setLoading(true)
      await sendPasswordResetEmail({ email })
      setComplete(true)
    } catch (error) {
      showAlertSnackbar({
        title: 'An error occured',
        message: (error as Error).message,
        type: 'error'
      })
    } finally {
      setLoading(false)
    }
  }

  if (complete) return <ForgotPasswordComplete email={email} />
  return (
    <LoginFrame withLogo withBacktToLogin>
      <Typography
        variant='h4'
        color='textPrimary'
        marginBottom={0.5}
        sx={{ fontWeight: 600 }}>
        Reset Your Password
      </Typography>
      <Typography variant='body1' color='textSecondary' marginBottom={4}>
        Please enter your email address
      </Typography>
      <Box
        component='form'
        onSubmit={onSubmit}
        display='flex'
        flexDirection='column'
        width='100%'
        maxWidth={400}>
        <TextField
          type='email'
          value={email}
          onChange={e => setEmail(e.target.value)}
          label='Email Address'
          placeholder='Please enter your email address'
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ marginBottom: 4 }}
          required
        />
        <Button
          type='submit'
          variant='contained'
          size='large'
          disabled={loading}>
          Reset Password
        </Button>
      </Box>
    </LoginFrame>
  )
}
